var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M459,0H51C23,0,0,23,0,51v408c0,28,23,51,51,51h408c28,0,51-23,51-51V51C510,23,487,0,459,0z M400.4,186.1c-2.5,117.3-76.5,198.9-188.7,204c-45.9,2.6-79.1-12.8-109.7-30.6c33.1,5.1,76.5-7.6,99.4-28 c-33.2-2.5-53.6-20.4-63.8-48.5c10.2,2.5,20.4,0,28.1,0c-30.6-10.2-51-28.1-53.6-68.9c7.7,5.1,17.9,7.6,28.1,7.6 c-22.9-12.8-38.3-61.2-20.4-91.8c33.2,35.7,73.9,66.3,140.3,71.4c-17.9-71.4,79.1-109.7,117.3-61.2c17.9-2.6,30.6-10.2,43.4-15.3 c-5.1,17.9-15.3,28.1-28,38.3c12.8-2.6,25.5-5.1,35.7-10.2C425.9,165.8,413.1,175.9,400.4,186.1z"}));
}

SocialTwitter.defaultProps = {"className":"icon-social","version":"1.1","id":"icon-twitter","x":"0px","y":"0px","viewBox":"0 0 510 510","style":{"enableBackground":"new 0 0 510 510"},"xmlSpace":"preserve"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
